import { useModal } from "components/Modal";
import { IButtonProps } from "components/Button";

import { RegisterModal } from "./RegisterModal";
import { RegisterButton } from "./RegisterButton";

interface IProps {
  registerBtnProps?: Omit<IButtonProps, "id">;
}

const Register = ({ registerBtnProps }: IProps) => {
  const { isOpen, onOpen, onClose } = useModal();

  return (
    <>
      <RegisterModal onClose={onClose} isOpen={isOpen} />
      <RegisterButton openRegisterModal={onOpen} {...registerBtnProps} />
    </>
  );
};

export { Register };
